// extracted by mini-css-extract-plugin
module.exports = {"ThirdPartyOrderingWrapper":"ThirdPartyOrderingWrapper___2buzn","ThirdPartyOrdering":"ThirdPartyOrdering___2ZV3S"};